import { baseURL } from './http.js';
import request from './request.js';


export default {
  getShoppingCartList: (item) => request(baseURL).post('/shoppingCart/listAll', item),
  // 删除购物车
  deleteShoppingCart: val => request(baseURL).post(`shoppingCart/delete?id=${val}`),
  // 批量删除购物车
  deleteShoppingCartIds: (item) => request(baseURL).post('/shoppingCart/deleteByIds', item),
  // 修改购物车数量
  updateShoppingCart: (item) => request(baseURL).post('/shoppingCart/update', item),
};